import faqs from "../assets/images/icons/faq.png";
import shipping from "../assets/images/icons/delivery-truck.png";
import contact from "../assets/images/icons/telephone.png";
import about from "../assets/images/icons/shop.png";

export const supportIcons = {
  faq: {
    icon: faqs,
    title: "FAQ",
    path: "/faq"
  },
  shipping: {
    icon: shipping,
    title: "Shipping Info",
    path: "/shipping-info"
  },
  contact: {
    icon: contact,
    title: "Contact Us",
    path: "/contactUs"
  },
  about: {
    icon: about,
    title: "About Us",
    path: "/about"
  }
};
